const apiconfig = {
  // 开发环境
  serve: {
    getUser: "http://192.168.2.200:51002"
  },
  //测试
  test: {
    getUser: 'http://192.168.2.200:51002',
  },
  // 生产环境
  build: {
    getUser: 'https://jq-api.jqsoft.vip',
  },
};
// 引入 env.json 文件
import env from './env.json';
// 导出不同接口地址
export default apiconfig[env.env];
